import requestTypes from "constants/requestTypes";

import { fetchNext } from "./request";
import { Version } from "./models/version";

const APP_WORKSPACE_URL = String(process.env.REACT_APP_WORKSPACE_URL);

export const getVersionDetails = async (): Promise<Version> => {
  const url = APP_WORKSPACE_URL + "/version";
  const resp = await fetchNext(requestTypes.GET, url, null);
  return resp;
};
